import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const { login } = useContext(AuthContext);

  useEffect(() => {
    setErrorMsg('');
  }, [password, username]);

  const onPressLogin = async (e) => {
    e.preventDefault();
    setIsFormSubmitted(true);
    setIsLoading(true);
    setErrorMsg('');

    try {
      const response = await login(username, password);
      if (response && response.status && response.status === 401) {
        setErrorMsg('Usuario o contraseña incorrectos. Por favor, verifica tus credenciales.');
      }
    } catch (error) {
      setErrorMsg('Error de conexión. Por favor, intenta nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const disableLogin = () =>
    (errorMsg && errorMsg.length > 0) ||
    username.length === 0 ||
    password.length === 0 ||
    isLoading;

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (errorMsg) setErrorMsg('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errorMsg) setErrorMsg('');
  };

  return (
    <div className="min-height-100vh">
      {/* Fondo con Gradiente y Elementos Decorativos */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          zIndex: 1,
        }}
      >
        {/* Elementos decorativos animados */}
        <div
          style={{
            position: 'absolute',
            top: '10%',
            right: '10%',
            width: '300px',
            height: '300px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            animation: 'float 6s ease-in-out infinite',
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            bottom: '15%',
            left: '5%',
            width: '200px',
            height: '200px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '50%',
            animation: 'float 8s ease-in-out infinite reverse',
          }}
        ></div>
        <div
          style={{
            position: 'absolute',
            top: '60%',
            right: '70%',
            width: '150px',
            height: '150px',
            background: 'rgba(255, 255, 255, 0.08)',
            borderRadius: '50%',
            animation: 'float 10s ease-in-out infinite',
          }}
        ></div>
      </div>

      {/* Contenido Principal */}
      <section className="hero is-fullheight" style={{ position: 'relative', zIndex: 2 }}>
        <div className="hero-body">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-5-desktop is-6-tablet is-10-mobile">
                {/* Card Principal */}
                <div
                  className="box"
                  style={{
                    borderRadius: '20px',
                    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
                    background: 'rgba(255, 255, 255, 0.98)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    animation: 'slideInUp 0.8s ease-out',
                    padding: '3rem',
                  }}
                >
                  {/* Logo y Header */}
                  <div className="has-text-centered mb-6">
                    <div
                      className="image-container mb-4"
                      style={{
                        display: 'inline-block',
                        borderRadius: '16px',
                        padding: '1rem',
                        background:
                          'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                      }}
                    >
                      <img
                        className="image"
                        src="/assets/images/radiopolis.png"
                        alt="Radiopolis Logo"
                        style={{
                          borderRadius: '12px',
                          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))',
                        }}
                      />
                    </div>
                    <h1 className="title is-4 has-text-grey-dark mb-2">Portal Afiliados</h1>
                    <p className="is-family-monospace has-text-primary is-size-7">
                      <span className="icon is-small mr-1">
                        <i className="fas fa-code-branch"></i>
                      </span>
                      Versión 1.0.8
                    </p>
                  </div>

                  {/* Formulario */}
                  <form onSubmit={onPressLogin}>
                    {/* Campo Usuario */}
                    <div className="field">
                      <label className="label has-text-weight-semibold has-text-grey-dark">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-user"></i>
                          </span>
                          <span>Usuario</span>
                        </span>
                      </label>
                      <div className="control has-icons-left has-icons-right">
                        <input
                          id="username"
                          className={`input is-medium ${
                            isFormSubmitted
                              ? username.length > 0
                                ? 'is-success'
                                : 'is-danger'
                              : ''
                          }`}
                          type="text"
                          placeholder="Ingresa tu nombre de usuario"
                          value={username}
                          onChange={handleUsernameChange}
                          autoFocus
                          autoComplete="username"
                          style={{
                            borderRadius: '10px',
                            transition: 'all 0.3s ease',
                          }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fas fa-user"></i>
                        </span>
                        {isFormSubmitted && username.length > 0 && (
                          <span className="icon is-small is-right has-text-success">
                            <i className="fas fa-check"></i>
                          </span>
                        )}
                      </div>
                      {isFormSubmitted && username.length === 0 && (
                        <p className="help is-danger">
                          <span className="icon is-small mr-1">
                            <i className="fas fa-exclamation-triangle"></i>
                          </span>
                          El campo usuario es obligatorio
                        </p>
                      )}
                    </div>

                    {/* Campo Contraseña */}
                    <div className="field">
                      <label className="label has-text-weight-semibold has-text-grey-dark">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-lock"></i>
                          </span>
                          <span>Contraseña</span>
                        </span>
                      </label>
                      <div className="control has-icons-left has-icons-right">
                        <input
                          id="password"
                          className={`input is-medium ${
                            errorMsg
                              ? 'is-danger'
                              : isFormSubmitted && password.length > 0
                              ? 'is-success'
                              : isFormSubmitted && password.length === 0
                              ? 'is-danger'
                              : ''
                          }`}
                          type={showPassword ? 'text' : 'password'}
                          placeholder="Ingresa tu contraseña"
                          value={password}
                          onChange={handlePasswordChange}
                          autoComplete="current-password"
                          style={{
                            borderRadius: '10px',
                            transition: 'all 0.3s ease',
                            paddingRight: '3rem', // Espacio para el ícono del ojo
                          }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fas fa-lock"></i>
                        </span>
                        <button
                          type="button" // Importante: type="button" para que no envíe el formulario
                          className="button is-white is-small"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                            zIndex: 10,
                            padding: '0.5rem',
                            borderRadius: '4px',
                          }}
                          title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                          tabIndex={0}
                        >
                          <span className="icon is-small">
                            <i
                              className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                              style={{ color: '#666' }}
                            ></i>
                          </span>
                        </button>
                      </div>
                      {errorMsg && (
                        <p className="help is-danger">
                          <span className="icon is-small mr-1">
                            <i className="fas fa-exclamation-circle"></i>
                          </span>
                          {errorMsg}
                        </p>
                      )}
                      {isFormSubmitted && !errorMsg && password.length === 0 && (
                        <p className="help is-danger">
                          <span className="icon is-small mr-1">
                            <i className="fas fa-exclamation-triangle"></i>
                          </span>
                          El campo contraseña es obligatorio
                        </p>
                      )}
                    </div>

                    {/* Botón de Login */}
                    <button
                      id="loginBtn"
                      type="submit"
                      className={`button is-medium is-fullwidth has-text-weight-semibold ${
                        isLoading ? 'is-loading' : ''
                      }`}
                      disabled={disableLogin()}
                      style={{
                        borderRadius: '10px',
                        background: disableLogin()
                          ? '#dbdbdb'
                          : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        color: 'white',
                        transition: 'all 0.3s ease',
                        transform: disableLogin() ? 'none' : 'translateY(0)',
                        boxShadow: disableLogin() ? 'none' : '0 6px 20px rgba(102, 126, 234, 0.4)',
                        minHeight: '3rem',
                      }}
                      onMouseEnter={(e) => {
                        if (!disableLogin()) {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.5)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!disableLogin()) {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                        }
                      }}
                    >
                      {!isLoading && (
                        <span className="icon mr-2">
                          <i className="fas fa-sign-in-alt"></i>
                        </span>
                      )}
                      <span>{isLoading ? 'Verificando credenciales...' : 'Iniciar Sesión'}</span>
                    </button>
                  </form>

                  {/* Enlaces Adicionales */}
                  <div
                    className="has-text-centered mt-5 pt-4"
                    style={{ borderTop: '1px solid #f5f5f5' }}
                  >
                    <a
                      href="/fp"
                      className="has-text-primary has-text-weight-semibold"
                      style={{
                        textDecoration: 'none',
                        transition: 'color 0.3s ease',
                      }}
                      onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
                      onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                    >
                      <span className="icon is-small mr-1">
                        <i className="fas fa-key"></i>
                      </span>
                      ¿Olvidaste tu contraseña?
                    </a>
                  </div>
                </div>

                {/* Información de Seguridad */}
                <div
                  className="box mt-4 has-text-centered"
                  style={{
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                  }}
                >
                  <div className="columns is-mobile">
                    <div className="column">
                      <span className="icon has-text-success mb-1">
                        <i className="fas fa-shield-alt"></i>
                      </span>
                      <p className="is-size-7 has-text-weight-semibold mb-0">Seguro</p>
                      <p className="is-size-7 has-text-grey">SSL 256-bit</p>
                    </div>
                    <div className="column">
                      <span className="icon has-text-info mb-1">
                        <i className="fas fa-clock"></i>
                      </span>
                      <p className="is-size-7 has-text-weight-semibold mb-0">24/7</p>
                      <p className="is-size-7 has-text-grey">Disponible</p>
                    </div>
                    <div className="column">
                      <span className="icon has-text-warning mb-1">
                        <i className="fas fa-headset"></i>
                      </span>
                      <p className="is-size-7 has-text-weight-semibold mb-0">Soporte</p>
                      <p className="is-size-7 has-text-grey">Técnico</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Estilos CSS Adicionales */}
      <style jsx>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .min-height-100vh {
          min-height: 100vh;
        }

        .is-clickable {
          cursor: pointer;
        }

        .button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .button:disabled:hover {
          transform: none !important;
        }

        /* Mejoras en inputs */
        .input:focus {
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
          border-color: #667eea;
        }

        .input.is-success {
          border-color: #48c78e;
        }

        .input.is-danger {
          border-color: #f14668;
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .box {
            margin: 1rem;
            padding: 2rem !important;
          }

          .image.is-128x128 {
            width: 96px;
            height: 96px;
          }
        }

        /* Focus states para accesibilidad */
        .button:focus {
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25) !important;
        }

        a:focus {
          outline: 2px solid #667eea;
          outline-offset: 2px;
        }

        /* Animación sutil para el logo */
        .image-container:hover img {
          transform: scale(1.05);
          transition: transform 0.3s ease;
        }

        .control .icon[role='button']:hover {
          background-color: rgba(0, 0, 0, 0.05);
          color: #333 !important;
        }

        .control .icon[role='button']:focus {
          outline: 2px solid #667eea;
          outline-offset: 2px;
        }

      `}</style>
    </div>
  );
}
